var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.channels.length > 0)?_c('section',{staticClass:"live-channel"},_vm._l((_vm.channels),function(item){return _c('nuxt-link',{key:item.id,class:{
      active:
        _vm.$route.query.channelId === item.id ||
        (!_vm.$route.query.channelId && item.id === 'all'),
    },attrs:{"to":("/live?channelId=" + (item.id || 'all'))}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }